// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.posCustomCheckboxWrapper {
  /* padding: 0.5rem; */
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: max-content;
}

.posCustomCheckboxLabel {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.posCustomCheckboxIconLabel {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.posCustomCheckboxIcon {
  border: 2px solid var(--checkBoxColor, #949494);
  border-radius: 4px;
  background: var(--surface-white);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  position: relative;
}

.posCustomCheckboxIcon.act {
  background-color: var(--checkBoxColor, #949494);
  border: none;
  padding: 1px;
}

.checkMark {
  width: 100%;
  height: 100%;
  position: relative;
  display: block;
}

.checkMark::before {
  content: "";
  position: absolute;
  width: 40%;
  height: 70%;
  border: solid var(--checkMarkColor, "white");
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -55%) rotate(45deg);
}

.hideDefaultIcon {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

/* ── Dark theme ── */
.dark .posCustomCheckboxIcon {
  background: #1e293b;
  border-color: #475569;
}

.dark .posCustomCheckboxIcon.act {
  background-color: var(--checkBoxColor, #94a3b8);
}`, "",{"version":3,"sources":["webpack://./client/src/customComponents/PosCustomCheckBox/PosCustomCheckBox.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,4CAA4C;EAC5C,yBAAyB;EACzB,wBAAwB;EACxB,QAAQ;EACR,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":[".posCustomCheckboxWrapper {\n  /* padding: 0.5rem; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  min-width: max-content;\n}\n\n.posCustomCheckboxLabel {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.posCustomCheckboxIconLabel {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.posCustomCheckboxIcon {\n  border: 2px solid var(--checkBoxColor, #949494);\n  border-radius: 4px;\n  background: var(--surface-white);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  cursor: pointer;\n  position: relative;\n}\n\n.posCustomCheckboxIcon.act {\n  background-color: var(--checkBoxColor, #949494);\n  border: none;\n  padding: 1px;\n}\n\n.checkMark {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: block;\n}\n\n.checkMark::before {\n  content: \"\";\n  position: absolute;\n  width: 40%;\n  height: 70%;\n  border: solid var(--checkMarkColor, \"white\");\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -55%) rotate(45deg);\n}\n\n.hideDefaultIcon {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  position: absolute;\n  width: 0;\n  height: 0;\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n}\n\n/* ── Dark theme ── */\n.dark .posCustomCheckboxIcon {\n  background: #1e293b;\n  border-color: #475569;\n}\n\n.dark .posCustomCheckboxIcon.act {\n  background-color: var(--checkBoxColor, #94a3b8);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
